import { logWithPrefix } from "@/plugins/logging";
const log = logWithPrefix("[store/conflict.js]");

const getDefaultState = () => {
  return {
    lan_ip: "",
    details: {},
  };
};

const state = getDefaultState();

const mutations = {
  SET_INFO(state, info) {
    state.lan_ip = info.lan_ip || "";
    state.details = info.detail ? JSON.parse(JSON.stringify(info.detail)) : {};
    log("@mu(SET_WARNING_MSG) state", state);
  },
};

const actions = {
  setInfo: ({ commit }, info) => {
    commit("SET_INFO", info);
    return info;
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
};
